import { Link } from "react-router-dom";

import Reveal from "../common/reveal";
import { SELECTED_WORK, WORK_RANGE } from "../../data/work";

const SelectedWork = () => (
	<Reveal as="section" id="work" className="wrap sec">
		<div className="sec-head">
			<div className="secnum">02 · Selected work</div>
			<div className="secmeta">{WORK_RANGE}</div>
		</div>

		<div className="rule-bottom">
			{SELECTED_WORK.map((entry, index) => (
				<div
					key={entry.company}
					className={
						"row " + (index === 0 ? "rule-top" : "rule-top-soft")
					}
				>
					<span className="row-index">{entry.index}</span>
					<div className="row-body">
						<div className="entry-title">{entry.company}</div>
						<div className="row-desc">{entry.description}</div>
					</div>
					<div className="row-meta">
						<div className="row-meta-role">{entry.role}</div>
						<div className="row-meta-years">{entry.years}</div>
					</div>
				</div>
			))}
		</div>

		<div style={{ marginTop: "28px" }}>
			<Link to="/practice" className="link-mono">
				The practice behind it →
			</Link>
		</div>
	</Reveal>
);

export default SelectedWork;
